import { Component } from '@angular/core';
import { MarketingCardContainer } from '../../../marketing-services/components/marketing-card-container/marketing-card-container';
import { CARD_INFO_ENUM, ICardInfoData } from '../../../../shared/interfaces/card-info.interface';
import { CardInfoService } from '../../../../shared/services/card-info.service';

@Component({
  selector: 'app-edge',
  standalone: true,
  imports: [MarketingCardContainer],
  templateUrl: './edge.component.html',
  styleUrls: ['./edge.component.scss']
})
export class EdgeComponent {
  public cardInfo: ICardInfoData[] = []

  constructor(private cardInfoService: CardInfoService) {
  }

  ngOnInit() {
    this.cardInfo = this.cardInfoService.getCardInfoData(CARD_INFO_ENUM.BUSINESS_MOBILE_CONSULTING);
  }

}
